/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link as ReactRouterLink } from "react-router-dom";
import { jsx, css } from "@emotion/core";
import { primary_l50, primary_s5_l70 } from "../lib/colors";

class Link extends Component {
  render() {
    const cleanProps = { ...this.props };
    delete cleanProps.primaryColor;
    delete cleanProps.uiVariantButton;
    delete cleanProps.dispatch;

    const { primaryColor, uiVariantButton } = this.props;

    return (
      <ReactRouterLink
        {...cleanProps}
        css={css`
          color: ${primaryColor};
          &:active,
          &.active,
          &:not(:disabled):not(.disabled):active {
            color: ${primaryColor};
            &:after {
              background-color: ${primaryColor};
            }
          }
          &:focus,
          &:hover {
            color: ${primary_l50(primaryColor)};
            &:after {
              background-color: ${primaryColor};
            }
          }
          &.btn {
            font-size: ${uiVariantButton === "3" ? "14px" : "12px"};
            text-transform: ${uiVariantButton === "3" ? "none" : "uppercase"};
            letter-spacing: ${uiVariantButton === "3" ? "0" : "0.5px"};
            border-radius: ${uiVariantButton === "1"
              ? "12px"
              : uiVariantButton === "3"
              ? "6px"
              : 0};
          }
          &.btn-cart {
            padding: ${uiVariantButton === "3" ? "15px 30px" : "17px 30px"};
          }
          &.btn-primary {
            color: white;
            background-color: ${primaryColor};
            border-color: ${primaryColor};
            &:focus,
            &:hover,
            &:active,
            &:not(:disabled):not(.disabled):active {
              color: white;
              background-color: ${primary_l50(primaryColor)};
              border-color: ${primary_l50(primaryColor)};
            }
          }
          &.btn-inverse {
            background-color: transparent;
            color: white;
            border-color: white;
            &:focus,
            &:hover,
            &:active,
            &:not(:disabled):not(.disabled):active {
              background-color: white;
              color: ${primaryColor};
            }
          }
          &.btn-outline {
            background-color: transparent;
            color: ${uiVariantButton === "3" ? "#4f4f4f" : primaryColor};
            border-color: ${primaryColor};
            &:focus,
            &:hover,
            &:active,
            &:not(:disabled):not(.disabled):active {
              background-color: ${primaryColor};
              color: white;
            }
          }
          &.btn-grey {
            background-color: transparent;
            color: ${primary_s5_l70(primaryColor)};
            border-color: ${primary_s5_l70(primaryColor)};
            &:focus,
            &:hover,
            &:active,
            &:not(:disabled):not(.disabled):active {
              background-color: ${primary_s5_l70(primaryColor)};
              color: white;
            }
          }
        `}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  primaryColor: state.store.singleStore.brandColor,
  uiVariantButton: state.store.singleStore.buttons,
});

export default connect(mapStateToProps)(Link);
